import axios from "axios";

const BACKEND_URL = (
  process.env.REACT_APP_BACKEND_URL ||
  "https://https-doriantelive-api-onrender-com.onrender.com"
).replace(/\/+$/, "");

export const API = `${BACKEND_URL}/api`;

// ---------------- Member Streaming Presets ----------------

export const getStreamPresets = async () =>
  (
    await axios.get(
      `${API}/stream-presets`,
      {
        withCredentials: true,
      }
    )
  ).data;

export const getYouTubeStatus = async () =>
  (await axios.get(`${API}/youtube/status`, {
    withCredentials: true,
  })).data;

export const getYouTubeBroadcasts = async () =>
  (await axios.get(`${API}/youtube/broadcasts`, {
    withCredentials: true,
  })).data;

export const applyYouTubePreset = async (payload) =>
  (await axios.post(`${API}/youtube/apply-preset`, payload, {
    withCredentials: true,
  })).data;

// ---------------- Twitch Channel Integration ----------------

export const getKickStatus = async () =>
  (await axios.get(`${API}/kick/status`, {
    withCredentials: true,
  })).data;

export const applyKickPreset = async (payload) =>
  (await axios.post(`${API}/kick/apply-preset`, payload, {
    withCredentials: true,
  })).data;

export const getTwitchStatus = async () =>
  (
    await axios.get(`${API}/twitch/status`, {
      withCredentials: true,
    })
  ).data;

export const applyTwitchPreset = async (payload) =>
  (
    await axios.post(`${API}/twitch/apply-preset`, payload, {
      withCredentials: true,
    })
  ).data;

export const saveStreamPresets = async (payload) =>
  (
    await axios.put(
      `${API}/stream-presets`,
      payload,
      {
        withCredentials: true,
      }
    )
  ).data;



export const sendContact = async (payload) =>
  (await axios.post(`${API}/contact`, payload)).data;

export const verifyLicense = async (key) =>
  (await axios.post(`${API}/license/verify`, { key })).data;


export const getAdminProducts = async ({
  creator_id,
  status,
} = {}) =>
  (
    await axios.get(
      `${API}/admin/products`,
      {
        params: {
          creator_id,
          status,
        },
        withCredentials: true,
      }
    )
  ).data;

export const createAdminProduct = async (payload) =>
  (
    await axios.post(
      `${API}/admin/products`,
      payload,
      {
        withCredentials: true,
      }
    )
  ).data;

  export const updateAdminProduct = async (productId, payload) =>
  (
    await axios.patch(
      `${API}/admin/products/${productId}`,
      payload,
      {
        withCredentials: true,
      }
    )
  ).data;

export const publishAdminProduct = async (productId) =>
  (
    await axios.post(
      `${API}/admin/products/${productId}/publish`,
      {},
      {
        withCredentials: true,
      }
    )
  ).data;  

export const updateAdminDesign = async (designId, payload) =>
  (
    await axios.patch(
      `${API}/admin/designs/${designId}`,
      payload,
      {
        withCredentials: true,
      }
    )
  ).data;  

export const getAdminCreators = async () =>
  (
    await axios.get(`${API}/admin/creators`, {
      params: { status: "ACTIVE" },
      withCredentials: true,
    })
  ).data;

export const getAdminStorefronts = async (creator_id) =>
  (
    await axios.get(`${API}/admin/storefronts`, {
      params: {
        status: "ACTIVE",
        creator_id,
      },
      withCredentials: true,
    })
  ).data;


export const getAdminDesigns = async () =>
    (
      await axios.get(`${API}/admin/designs`, {
        withCredentials: true,
      })
    ).data;

    export const getAdminAssetPipelineRecords = async () =>
  (
    await axios.get(`${API}/admin/asset-pipeline-records`, {
      withCredentials: true,
    })
  ).data;

export const getAdminPricing = async () =>
  (
    await axios.get(`${API}/admin/pricing`, {
      withCredentials: true,
    })
  ).data;

export const runAdminPublishPipeline = async (formData) =>
  (
    await axios.post(
      `${API}/admin/publish-pipeline`,
      formData,
      {
        withCredentials: true,
      }
    )
  ).data;

